(function () {

    /**
     *  vue-bridge-webview config
     *
     * @type {{bridgeWebViewDelay: number}}
     */
    var bridgeConfig = {
        bridgeWebViewDelay: 500,
        callHandle: {}, // bridge android / ios
    }

    var cache = []

    var $bridge = {
        registerHandler: function () {
            cache.push({
                type: 'registerHandler',
                params: [...arguments]
            })
        },
        callHandler: function () {
            cache.push({
                type: 'callHandler',
                params: [...arguments]
            })
        }
    };

    /* ios 初始化 */
    function setupWebViewJavascriptBridge(callback) {
        if (window.WebViewJavascriptBridge) { return callback(window.WebViewJavascriptBridge); }
        if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback); }
        window.WVJBCallbacks = [callback];
        var WVJBIframe = document.createElement('iframe');
        WVJBIframe.style.display = 'none';
        WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';
        document.documentElement.appendChild(WVJBIframe);
        setTimeout(function () { document.documentElement.removeChild(WVJBIframe) }, 0)
    }

    /* 用于创建桥接对象的函数 , android 初始化 */
    function connectWebViewJavascriptBridge(callback) {
        //如果桥接对象已存在，则直接调用callback函数
        if (window.WebViewJavascriptBridge) {
            callback(window.WebViewJavascriptBridge)
        }
        //否则添加一个监听器来执行callback函数
        else {
            document.addEventListener('WebViewJavascriptBridgeReady', function () {
                callback(window.WebViewJavascriptBridge)
            }, false)
        }
    }
    /* ios/android */
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        //ios 新版桥接
        if (/(kbapp)/i.test(navigator.userAgent)) {
            setupWebViewJavascriptBridge(function (bridge) {
                $bridge = bridge;
                initRegister(bridge);
            })
        } else {
            connectWebViewJavascriptBridge(function (bridge) {
                $bridge = bridge;
                initRegister(bridge);
            })
        }
    } else if (/(Android)/i.test(navigator.userAgent)) {
        connectWebViewJavascriptBridge(function (bridge) {
            $bridge = bridge;
            initRegister(bridge);
        })
    }

    // IOS中会主动调用该方法,不清楚为什么
    window.setWebViewFlag = () => { }

    function initRegister(bridge) {
        bridge.init && bridge.init(function (message, responseCallback) {
            var data = { 'Javascript Responds': 'Wee!' };
            responseCallback(data)
        });

        bridge.registerHandler('AppPayResult', function (data, responseCallback) {
            var responseData = { 'Javascript Says': 'Right back atcha!' };
            responseCallback(responseData)
        });

        bridge.registerHandler('UploadImageResult', function (data, responseCallback) {

            var responseData = { 'Javascript Says': 'Upload Success!' };
            responseCallback(responseData)
        });

        bridge.registerHandler('RichInputResult', function (data, responseCallback) {
            var responseData = { 'Javascript Says': 'Upload Success!' };
            responseCallback(responseData)
        });
        bridge.registerHandler('CommonResult', function (data, responseCallback) {
            var responseData = { 'Javascript Says': 'CommonResult Success!' };
            responseCallback(responseData)
        });
        bridge.registerHandler('CommonRequest', function (data, responseCallback) {
            var responseData = { 'Javascript Says': 'CommonRequest Success!' };
            responseCallback(responseData)
        });

        cache.forEach(({ type, params }) => {
            switch (type) {
                case 'registerHandler':
                    bridge.registerHandler(...params)
                    break;
                case 'callHandler':
                    bridge.callHandler(...params)
                    break;
                default:
                    break;
            }
        })
    }

    var VueBridgeWebView = {
        /**
         *  Android / IOS 调用JS,需要明确调用的`function名称` .
         *
         *
         * @param name `function name`
         * @param registerCallback 回调的响应事件
         */
        registerHandler: function (name, registerCallback) {
            if ($bridge['registerHandler']) {
                setTimeout(function () {
                    $bridge.registerHandler(name, registerCallback)
                }, bridgeConfig.bridgeWebViewDelay)

            } else {
                console.log("don't built-in WebView invoking ", name, '{registerHandler}')
            }
        },

        /**
         *  JS 调用 Android / IOS
         *
         *  name: 回调名称, android/ios 名称 ,eg: 'getUserInfo'
         *  params 请求参数, eg: { 'userId' : 1}
         *  callback: response(响应函数)
         *
         *  eg: this.$bridge.callHandler('getUserInfo',{'userId':1},function(data){...})
         *
         */
        callHandler: function (name, params, callback) {
            if ($bridge['callHandler']) {
                try {
                    $bridge.callHandler(name, params, function (data) {
                        if (typeof callback == 'function') {
                            /* 解决部分系统加载延迟导致 ios/android 不响应问题 */
                            setTimeout(function () {
                                callback(data);
                            }, bridgeConfig.bridgeWebViewDelay)
                        }
                    })
                    //TODO  待商榷 可优化
                    $bridge.registerHandler("CommonResult", callback);
                    $bridge.registerHandler("CommonRequest", callback);
                } catch (error) {
                    console.log(error);
                }
            } else {
                console.log("don't built-in WebView invoking ", name, '{callHandler}')
            }
        }
    }

    if (typeof exports == "object") {
        module.exports = VueBridgeWebView;
    } else if (typeof define == "function" && define.amd) {
        define([], function () { return VueBridgeWebView; })
    } else if (window.Vue) {
        window.$bridge = VueBridgeWebView
        Vue.prototype.$bridge = VueBridgeWebView
    } else {
        window.$bridge = VueBridgeWebView
    }

})()
